import React from 'react';
import './StartSlide.css'


interface StartSlideProps {
    startQuiz: () => void;
}

function StartSlide({startQuiz}: StartSlideProps) {

  return (
    <div className="start-slide slide">
      <div>
        <h1>Discover Your Empowered Mom Style</h1>
        <h2>Are you the Balance Builder, Boundary Setter, Momentum Maker, or Visionary Leader?</h2>
      </div>
      <p>Every working mom leads her life in a unique way. This quick quiz will reveal your Empowered Mom Style — your strengths, your hidden challenges, and the first step to living and leading with more clarity, ease, and confidence.</p>
      <p>In just a few minutes, you’ll gain insight into how you show up, where you get stuck, and how to unlock more momentum in both your family and your career.</p>
      <h3>Ready to find out your Empowered Mom Style?</h3>
      <button onClick={startQuiz} className='button'>Let's Go!</button>
    </div>
  );
};

export default StartSlide;